import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const LeagueOfLegend = () => {
  return (
    <SportsLayoutComp name={'League Of Legend'}/>
  )
}

export default LeagueOfLegend